module.exports = __webpack_public_path__ + "static/media/SBD_02.40155e75.jpeg";